module.exports = __webpack_public_path__ + "static/img/5.11e9edc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/img/5.png
// module id = YWhL
// module chunks = 0